<div class="modal-header" mat-dialog-title>
  <div class="modal-header-titles">
    <h2 class="modal-title">Justificativa obrigatória</h2>
  </div>
  <div class="modal-header-close-btn-container">
    <button mat-icon-button type="button" class="modal-close-btn" aria-label="Fechar" (click)="cancelar()">
      <mat-icon class="material-symbols-outlined">close</mat-icon>
    </button>
  </div>
</div>

<mat-dialog-content class="modal-content">
  <p>
    Mover de <b>{{ data.origemNome }}</b> para <b>{{ data.destinoNome }}</b> exige uma justificativa,
    que será registrada no histórico do card.
  </p>
  <mat-form-field appearance="outline" class="w-100">
    <mat-label>Justificativa</mat-label>
    <textarea matInput rows="3" required [(ngModel)]="justificativa"
      placeholder="Descreva o motivo da movimentação"></textarea>
    <mat-hint align="end">{{ justificativa.trim().length }} / {{ tamanhoMinimo }}</mat-hint>
  </mat-form-field>
</mat-dialog-content>

<mat-dialog-actions class="modal-footer">
  <button mat-stroked-button type="button" class="btn-secondary" (click)="cancelar()">Cancelar</button>
  <span [matTooltip]="'Informe a justificativa com pelo menos ' + tamanhoMinimo + ' caracteres.'" [matTooltipDisabled]="valida">
    <button mat-flat-button type="button" class="btn-primary" [disabled]="!valida" (click)="confirmar()">
      <mat-icon class="material-symbols-outlined">check</mat-icon>
      Confirmar movimentação
    </button>
  </span>
</mat-dialog-actions>
